import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M6.75 5.25H17.25V16.375L12 12L6.75 16.375V5.25Z" fill="currentColor" />
	</SVG>
);
